import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import React from 'react';
import { ToolbarMenuItemWrapperProps } from 'features/toolbar/types';
import { useContentLibraryControl } from 'features/toolbar/toolbar/controls/content-library/useContentLibraryControl';

const ContentLibraryControl = ({ onClick }: ToolbarMenuItemWrapperProps) => {
  const { active, label, toggleContentLibrary, isFeatureAvailable, icon } =
    useContentLibraryControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    toggleContentLibrary();
  };

  return (
    <ToolbarMenuItem
      id="content-library-control"
      overlay={label}
      ariaLabel={label}
      active={active}
      icon={icon}
      onClick={handleClick}
    />
  );
};

export default ContentLibraryControl;
